const initState = {
  vendor: {},
  vendorOrders: [],
  userOrders: [],
};
const sharedReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_VENDOR_DETAILS":
      return { ...state, vendor: action.payload.data[0] };
    case "GET_VENDOR_DETAILS_ERROR":
      return state;
    case "GET_VENDOR_ORDERS":
      return { ...state, vendorOrders: action.payload.data };
    case "GET_VENDOR_ORDERS_ERROR":
      return state;
    case "GET_USER_ORDERS":
      return { ...state, userOrders: action.payload.data };
    case "GET_USER_ORDERS_ERROR":
      return state;
    default:
      return state;
  }
};
export default sharedReducer;
